import { format, parseISO } from "date-fns";

export const formatDate = (
    date: string,
    includeTime: boolean = false
): string => {
    const dateFormat = includeTime
        ? "MMMM dd, yyyy 'at' h:mm a"
        : "MMMM dd, yyyy";
    return format(parseISO(date), dateFormat);
};
